import React from 'react'
import PropTypes from 'prop-types'
import Link from '@salesforce/retail-react-app/app/components/link'
import {Text, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {productUrlBuilder, rebuildPathWithParams} from '../../../utils/url'
import {ChevronRightIcon} from '../../../components/icons'
import {FormattedMessage} from 'react-intl'

const QuickViewFullProductLink = ({styles, product, variationParams, onClick}) => {
    const productUrl = product
        ? rebuildPathWithParams(productUrlBuilder(product), variationParams || {})
        : null

    if (!product?.name || !productUrl) return null

    return (
        <Link
            to={productUrl}
            data-testid="quick-view-full-product-link"
            onClick={onClick}
            {...styles.fullProductLink}
        >
            <Text {...styles.fullProductText}>
                <FormattedMessage
                    id="qv.full_product_link"
                    defaultMessage="View Full Product Information"
                />
            </Text>
            <Box as='span' {...styles.fullProductIcon}>
                <ChevronRightIcon />
            </Box>
        </Link>
    )
}

QuickViewFullProductLink.propTypes = {
    styles: PropTypes.object,
    product: PropTypes.object,
    variationParams: PropTypes.object,
    onClick: PropTypes.func
}

export default QuickViewFullProductLink
